import type { PipeStatusRecord, OwnerPipeStatus } from "@/types"

// Legacy config kept for Owner model (still uses integer enum)
export const OWNER_PIPE_STATUS_CONFIG: Record<string, { label: string; bg: string; text: string }> = {
  to_contact: { label: "A contacter", bg: "#e0e7ff", text: "#3730a3" },
  to_be_treated: { label: "A traiter", bg: "#dbeafe", text: "#1e40af" },
  stand_by: { label: "En attente", bg: "#f1f5f9", text: "#475569" },
  contacted: { label: "Contacté", bg: "#ccfbf1", text: "#115e59" },
  qualified: { label: "Qualifié", bg: "#99f6e4", text: "#0f766e" },
  follow_up: { label: "Suivi", bg: "#a7f3d0", text: "#065f46" },
  feasibility_study: { label: "Étude de faisabilité", bg: "#fef3c7", text: "#92400e" },
  visited: { label: "Visité", bg: "#fde68a", text: "#78350f" },
  offer_submitted: { label: "Offre soumise", bg: "#ffedd5", text: "#9a3412" },
  mandate_signed: { label: "Mandat signé", bg: "#fed7aa", text: "#7c2d12" },
  permit_preparation: { label: "Préparation permis", bg: "#ede9fe", text: "#5b21b6" },
  permit_review: { label: "Instruction permis", bg: "#ddd6fe", text: "#4c1d95" },
  signed: { label: "Signé", bg: "#bbf7d0", text: "#14532d" },
  sales_phase: { label: "Phase commerciale", bg: "#86efac", text: "#166534" },
  to_transfer: { label: "A transférer", bg: "#bfdbfe", text: "#1e3a5f" },
  transferred: { label: "Transféré", bg: "#93c5fd", text: "#1e3a8a" },
  closed: { label: "Clôturé", bg: "#e5e7eb", text: "#374151" },
  wrong_contact: { label: "Mauvais contact", bg: "#fecaca", text: "#991b1b" },
  not_interested: { label: "Pas intéressé", bg: "#fca5a5", text: "#7f1d1d" },
  not_selling: { label: "Ne vend pas", bg: "#f87171", text: "#7f1d1d" },
}

type Props = {
  pipeStatus: PipeStatusRecord
  className?: string
}

export function PipeStatusBadge({ pipeStatus, className }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium ${className || ""}`}
      style={{ backgroundColor: pipeStatus.bg_color, color: pipeStatus.text_color }}
    >
      {pipeStatus.label}
    </span>
  )
}

type OwnerProps = {
  status: OwnerPipeStatus
  className?: string
}

export function OwnerPipeStatusBadge({ status, className }: OwnerProps) {
  const config = OWNER_PIPE_STATUS_CONFIG[status] || { label: status, bg: "#f1f5f9", text: "#475569" }

  return (
    <span
      className={`inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium ${className || ""}`}
      style={{ backgroundColor: config.bg, color: config.text }}
    >
      {config.label}
    </span>
  )
}
